import React from 'react';

import { Card, CardContent } from 'ui';

import type { ContentPageModel } from '../get-content-page';

interface ContentPageProps {
  page: ContentPageModel;
}

const ContentPage: React.FC<ContentPageProps> = ({ page }) => {
  return (
    <Card header={page.title}>
      <CardContent>
        <div dangerouslySetInnerHTML={{ __html: page.html }} />
      </CardContent>
    </Card>
  );
};

export default ContentPage;
